import { z } from "zod";
import {
  TovParseStatusSchema,
  TovSourceStatusSchema,
  TovSourceTypeSchema,
} from "../../enums/tov";

export const TovParseJobResponseSchema = z.object({
  id: z.uuid(),
  sourceId: z.uuid(),
  provider: z.string(),
  providerJobId: z.string(),
  providerFileId: z.string().nullable(),
  parseTier: z.string(),
  parseVersion: z.string(),
  requestedExpand: z.array(z.string()),
  status: TovParseStatusSchema,
  errorMessage: z.string().nullable(),
  rawMetadata: z.unknown().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  completedAt: z.iso.datetime().nullable(),
});
export type TovParseJobResponse = z.infer<typeof TovParseJobResponseSchema>;

export const TovSourceResponseSchema = z.object({
  id: z.uuid(),
  versionId: z.uuid(),
  sourceType: TovSourceTypeSchema,
  title: z.string(),
  mimeType: z.string().nullable(),
  storageKey: z.string().nullable(),
  sourceUrl: z.string().nullable(),
  sha256: z.string().nullable(),
  status: TovSourceStatusSchema,
  failureReason: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  parseJobs: z.array(TovParseJobResponseSchema),
  readableLocalPath: z.string().nullable(),
  readableUrl: z.string().nullable(),
});
export type TovSourceResponse = z.infer<typeof TovSourceResponseSchema>;

export const TovSourceListResponseSchema = z.object({
  sources: z.array(TovSourceResponseSchema),
});
export type TovSourceListResponse = z.infer<typeof TovSourceListResponseSchema>;

export const TovParsedPageResponseSchema = z.object({
  id: z.uuid(),
  sourceId: z.uuid(),
  parseJobId: z.uuid(),
  pageNumber: z.number().int(),
  markdown: z.string(),
  text: z.string().nullable(),
  items: z.unknown().nullable(),
  metadata: z.unknown().nullable(),
  createdAt: z.iso.datetime(),
});
export type TovParsedPageResponse = z.infer<typeof TovParsedPageResponseSchema>;

export const TovParsedPageListResponseSchema = z.object({
  pages: z.array(TovParsedPageResponseSchema),
});
export type TovParsedPageListResponse = z.infer<
  typeof TovParsedPageListResponseSchema
>;
